/**
 * Toast notification utilities using SweetAlert2
 */
import Swal from 'sweetalert2';

/**
 * Show success toast notification
 * @param {string} message 
 */
export function showSuccess(message) {
    Swal.fire({
        icon: 'success',
        title: 'Success',
        text: message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
}

/**
 * Show error toast notification
 * @param {string} message 
 */
export function showError(message) {
    Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
    });
}

/**
 * Show info toast notification
 * @param {string} message 
 */
export function showInfo(message) {
    Swal.fire({
        icon: 'info',
        title: 'Info',
        text: message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
}

/**
 * Show warning toast notification
 * @param {string} message 
 */
export function showWarning(message) {
    Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3500,
        timerProgressBar: true,
    });
}

/**
 * Show confirmation dialog
 * @param {string} title 
 * @param {string} text 
 * @returns {Promise<boolean>}
 */
export async function showConfirm(title, text) {
    const result = await Swal.fire({
        title,
        text,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel'
    });

    return result.isConfirmed;
}
